import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import { Cart } from '../models';

export default function useNumCartItems({ id, email }) {
  return useQuery({
    enabled: !!(id && email),
    queryKey: [QueryKeys.cart, QueryKeys.numItems],
    queryFn: () => (
      Cart
        .where({ forEmail: [id, email] })
        .per(0)
        .stats({ numItems: 'count' })
        .all()
        .then((res) => res.meta.stats.num_items.count)
        .catch(() => 0)
    ),
  });
}
